export const businessData = {
  name: "Herrefrisør",
  tagline: "Over 50 års erfaring på Nørrebro",
  address: {
    street: "Thorsgade 4",
    postal: "2200 København N",
    country: "Danmark"
  },
  phone: "+45 35 85 09 84",
  openingHours: [
    { day: "Mandag", hours: "10.30–17.30" },
    { day: "Tirsdag", hours: "10.30–17.30" },
    { day: "Onsdag", hours: "Lukket" },
    { day: "Torsdag", hours: "10.30–17.30" },
    { day: "Fredag", hours: "10.30–17.30" },
    { day: "Lørdag", hours: "Lukket" },
    { day: "Søndag", hours: "Lukket" }
  ],
  services: [
    {
      name: "Herreklip",
      description: "Klassisk herreklip med saks og maskine",
      price: "170 kr."
    }
  ],
  averageRating: 4.8,
  totalReviews: 127,
  reviews: [
    {
      id: 1,
      author: "Mikkel S.",
      rating: 5,
      text: "Måske Københavns mest erfarne frisør. Ole har klippet mig i over 10 år, og jeg kommer aldrig andre steder hen.",
      date: "2024"
    },
    {
      id: 2,
      author: "Thomas J.",
      rating: 5,
      text: "En ægte Nørrebro salon. Intet pjat, bare godt håndværk og en god snak.",
      date: "2024"
    },
    {
      id: 3,
      author: "Lars K.",
      rating: 5,
      text: "Ole er en af de sidste af sin slags. Her får man tid og kvalitet – ikke masseproduktion.",
      date: "2023"
    },
    {
      id: 4,
      author: "Peter M.",
      rating: 4,
      text: "Autentisk og professionel. Den klassiske frisøroplevelse som den burde være.",
      date: "2023"
    },
    {
      id: 5,
      author: "Jesper H.",
      rating: 5,
      text: "Fantastisk service og altid en hyggelig stemning. Man føler sig velkommen hver gang.",
      date: "2024"
    },
    {
      id: 6,
      author: "Anders N.",
      rating: 5,
      text: "Har været kunde i mange år. Ole er dygtig og har altid styr på sagerne.",
      date: "2023"
    }
  ],
  images: {
    hero: "https://images.unsplash.com/photo-1759142449398-89357aa1bb36",
    about: "https://images.unsplash.com/photo-1758171669999-f2f137991e70",
    service: "https://images.unsplash.com/photo-1762479903293-c7708672cc15",
    tools: "https://images.unsplash.com/photo-1762186540775-11c875d3f26d",
    vintage: "https://images.unsplash.com/photo-1763669029167-fe7a6619219d"
  }
};